/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserFeedbackContent } from './UserFeedbackContent';
import {
    UserFeedbackContentFromJSON,
    UserFeedbackContentFromJSONTyped,
    UserFeedbackContentToJSON,
    UserFeedbackContentToJSONTyped,
} from './UserFeedbackContent';

/**
 * Request model for creating events.
 * @export
 * @interface EventRequest
 */
export interface EventRequest {
    /**
     * Event type (e.g., 'UserFeedback', 'UserInteraction', 'SystemLog', 'Error')
     * @type {string}
     * @memberof EventRequest
     */
    type: string;
    /**
     * User feedback content structure
     * @type {UserFeedbackContent}
     * @memberof EventRequest
     */
    content: UserFeedbackContent;
    /**
     * ISO 8601 formatted timestamp when the event occurred
     * @type {Date}
     * @memberof EventRequest
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the EventRequest interface.
 */
export function instanceOfEventRequest(value: object): value is EventRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function EventRequestFromJSON(json: any): EventRequest {
    return EventRequestFromJSONTyped(json, false);
}

export function EventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'content': UserFeedbackContentFromJSON(json['content']),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function EventRequestToJSON(json: any): EventRequest {
    return EventRequestToJSONTyped(json, false);
}

export function EventRequestToJSONTyped(value?: EventRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'content': UserFeedbackContentToJSON(value['content']),
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

